//#region src/interfaces/AgentConfigurationInterfaces.ts
var e = { SEARCH_AGENT: "SEARCH_AGENT" };
//#endregion
export { e as AGENT_TYPES };

//# sourceMappingURL=AgentConfigurationInterfaces.js.map